import React, {Component} from 'react';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {Link, Route, Redirect, Switch} from 'react-router-dom';
import {requestSurvey} from '../../actions/action_survey';
import Loader from '../Loader';
import Title from '../Title';
import Alert from '../Alert';
import messages from '../../../res/translations/messages';
import Icon from '../Icon';
import WaveTrackers from './trackers/WaveTrackers';
import WaveCreate from './trackers/WaveCreate';
import WaveEdit from './trackers/WaveEdit';

class SurveyTrackers extends Component {
    componentDidMount() {
        this.props.requestSurvey(this.props.match.params.id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.props.requestSurvey(this.props.match.params.id);
        }
    }

    render() {
        const {item, loading, error, match} = this.props;
        const survey = (item && item.id === match.params.id) ? item : null;
        return (error && <Alert error={error} /> || (
            <div className="row">
                <div className="col-md-2 col-12">
                    <Link className="navbar-brand" to="/surveys">
                        <button type="button" className="btn btn-outline-primary btn-sm">
                            <Icon icon="arrow_left" /> <FormattedMessage {...messages.buttons.back} />
                        </button>
                    </Link>
                </div>
                <div className="col-md-8 col-12">
                    <Title>{survey && survey.name}</Title>
                    {loading && <Loader overlay={!!(item)} />}
                    {survey && (
                        <Switch>
                            <Route exact path={`${match.path}/wave/create`} component={WaveCreate} />
                            <Route exact path={`${match.path}/wave/:waveId/edit`} component={WaveEdit} />
                            <Route exact path={`${match.path}/wave/:waveId`} component={WaveTrackers} />
                            <Redirect to={`${match.url}/wave/${item.waves[item.waves.length - 1].id}`} />
                        </Switch>
                    )}
                </div>
            </div>
        ));
    }
}

const mapStateToProps = (state) => {
    return {
        item: state.survey.item,
        loading: state.survey.loading,
        error: state.survey.error,
    };
};

export default connect(mapStateToProps, {requestSurvey})(SurveyTrackers);
